import { getModuleNamespace } from '../../../utils';

// Not using arrow function syntax in certain mutations to enable access to rootState via 'this' keyword
export default {
    displaySelectedCableInputTool: (state, payload) => state.selectedCableInputTool = payload,
    setCableSelectionMessageType: (state, type) => state.cableSelectionMessageType = type,
    setCablesSelectedCount: function(state) {
        let vinCount = 0;
        let mmyCount = 0;
        let manualSelectionData = 0;
        let activeCableSelection = getModuleNamespace(this, state)[0];

        if (this.state[activeCableSelection].vin.submittedVinData) {
            vinCount = this.state[activeCableSelection].vin.submittedVinData.length;
        }

        if (this.state[activeCableSelection].mmy.submittedMMYData) {
            mmyCount = this.state[activeCableSelection].mmy.submittedMMYData.reduce((prev,next) => prev + next.quantity, 0);
        }

        if (this.state[activeCableSelection].manualSelection.manualSelectionData) {
            manualSelectionData = Object.values(this.state[activeCableSelection].manualSelection.manualSelectionData).reduce((prev, next) => prev + next, 0)
        }
        state.cablesSelectedCount = vinCount + mmyCount + manualSelectionData;
    },
    setCablesNeededCount: (state, quantity) => state.cablesNeededCount = quantity,
    setCableSelectionMessage: (state, message) => state.cableSelectionMessage = message,
    setTotalCablesSubmittedData: function(state) {
        let activeCableSelection = getModuleNamespace(this, state)[0];
        let cleanedManualSelectionData = [];
        for (let cableSku in this.state[activeCableSelection].manualSelection.manualSelectionData) {
            let quantity = this.state[activeCableSelection].manualSelection.manualSelectionData[cableSku]
            if (quantity > 0) {
                cleanedManualSelectionData.push({
                    cable: cableSku,
                    quantity:  quantity,
                    type: 'manualSelection',
                    customerInput: 'plug type'
                })
            }
        }
        state.totalCablesSubmittedData = [...this.state[activeCableSelection].vin.submittedVinData, ...this.state[activeCableSelection].mmy.submittedMMYData, ...cleanedManualSelectionData];
    },
    clearTotalCablesSubmittedData: (state) => state.totalCablesSubmittedData = [],
    setSelectedAdditionalAccessoryOption: (state, option) => state.selectedAdditionalAccessoryOption = option,
}
